export default function () {
  const widgetName = 'cardWidgetQuickNav';
  const widgetOpts = cardWidgetQuickNavOpts;

  const isMobile = window.innerWidth <= 800;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    cardWidgetLoaded: function (data) {
      const widgetCount = data.items.length;
      if (widgetCount == 0) {
        $(`#${widgetName}`).remove();
      } else {
        $(`#${widgetName}`).show();
        addButtonClass();
        removeButtonWrap();
        removeHref(data);
      }
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    link: isMobile ? ['all'] : [], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 4,
    moreButton: {
      visible: true,
      text: 'MORE',
    },
    buyNowButton: {
      visible: true,
      text: 'BUY NOW',
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: false,
    textOverImage: true,
  });
}

function addButtonClass() {
  $('#cardWidgetQuickNav .buttonwrap a').addClass('button');
}

// remove buttonwrap if empty
function removeButtonWrap() {
  $('#cardWidgetQuickNav .buttonwrap').each(function () {
    if ($.trim($(this).html()) === '') {
      $(this).remove();
    }
  });
}

function removeHref(data) {
  $('#cardWidgetQuickNav .card-widget-item').each(function (x, item) {
    if (data.items[x]?.URL === null) {
      $(item).removeAttr('href');
    }
  });
}
